import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import appConfig from '../appConfig';
import useLocalStorage from '../hooks/useLocalstorage';
import { LAST_USED_APP } from '../constants/localstorageKeys';

const availableApps = appConfig.clientApps;

const Portal = () => {
	const history = useHistory();
	const location = useLocation();
	const [lastUsedProduct] = useLocalStorage(LAST_USED_APP);

	// NOTE: Redirecting from root route to the last used product
	React.useEffect(() => {
		const activeApp = availableApps.find((app) => app.name === lastUsedProduct) ?? availableApps[0];

		history.replace(activeApp.link + location.search, {});
	}, [history, location.search, lastUsedProduct]);

	return (
		<>
			<Helmet title="Home" />
			<h1>Home</h1>
		</>
	);
};

export default Portal;
